'use strict';
function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

(function ($) {
    if ($('.template-product-fan-builder').length) {
        if (getUrlParameter('team')) {
            $.each(blade_teams, function (i, team) {
                var querystringTeamID = getUrlParameter('team');

                if (querystringTeamID == team.id) {
                    $('.page-title').html('Build Your Custom ' + team.title + ' Hockey Ceiling Fan');

                    //<img src= "' + team.thumb + '" alt="' + team.title + ' Logo" />');
                    $('#fanfeatureimage').attr('src', team.thumb).addClass('custom');
                }
            });
        }

        //Build the fan blade team picker.
        var $bladeTeamOptions = $("#bladeteampicker .select");
        $bladeTeamOptions.html('');

        $.each(blade_teams, function (i, team) {
            var buttonClass = (team.tags.includes('Western Conference') || team.tags.includes('Eastern Conference') ? 'active' : 'hidden');

            $bladeTeamOptions.append("<div class=\"option " + buttonClass + "\" data-teamid=\"" + team.id + "\" data-tags=\"" + team.tags.toString() + "\"><img src=\"" + team.thumb + "\" alt=\"" + team.title + " Logo\" /><br/>" + team.title + "</div>");
        });
        
        //Build the fan light fixture lens team picker.
        var $lensTeamOptions = $("#lensteampicker .select");
        $lensTeamOptions.html('');

        $.each(lens_teams, function (i, team) {
            var buttonClass = (team.tags.includes('Western Conference') || team.tags.includes('Eastern Conference') ? 'active' : 'hidden');

            $lensTeamOptions.append("<div class=\"option " + buttonClass + "\" data-teamid=\"" + team.id + "\" data-tags=\"" + team.tags.toString() + "\"><img src=\"" + team.thumb + "\" alt=\"" + team.title + " Logo\" /><br/>" + team.title + "</div>");
        });

        //Add a click handler when someone selects to filter the teams.
        $('body').on('click', '#bladeteampicker .tag-selector .tag-option', function (e) {
            e.preventDefault();
            
            $('#bladeteampicker .tag-option').removeClass('active');
            $(this).addClass('active');
            $('#bladeteampicker .option').hide(0).removeClass('active');

            var tag = $(this).attr('data-name');

            if (tag == 'all') {
                tag = 'Conference';
            }

            $('#bladeteampicker .option[data-tags*="' + tag + '"]').show(0).removeClass('hidden').addClass('active');
        });

        //Add a click handler for the fan fixture option selector.
        $('.fan-fixture-option').on('click', function (e) {
            e.preventDefault();
            
            // Reset the active blade.
            $activeBlade = ''; 
            $('.fan-fixture-option').removeClass('active');
            $(this).addClass('active');
            productVariantID = $(this).data('variantid');
            var fixture = $(this).attr('data-fixture');

            //Build our custom fan with the select blade combination.
            $('#fan-customizer .fan-fixture .fixture').hide();
            $('#fan-customizer .fan-fixture .fixture.' + fixture).show();

            if (fixture == 'hockey-puck') {
                $('#fan-customizer .fan-fixture.hockey-puck').addClass('default').find('img.lens').attr('src', blankFixtureLens);
            }

            $('.blade-combo-option img').each(function() {
                $(this).attr('src', $(this).data('img-' + fixture));
                console.log($(this), $(this).data('img-' + fixture));
            });

            //The user changed the blade combo, so slide up the cart section and slide down the builder.
            $('#addtocartwrap').slideUp(500);
            $('#fan-customizer').slideUp(500);
            $('#blade-combo-picker').slideDown(500);

            //Scroll to the fan customizer
            $('html,body').animate({ scrollTop: $('#blade-combo-picker').offset().top - 20 }, 'slow');
        });

        $('.fan-fixture-option[data-fixture="hockey-puck"]').trigger('click');

        //Add a click handler for the blade combo selector.
        $('.blade-combo-option').on('click', function (e) {
            e.preventDefault();

            // Reset the active blade.
            $activeBlade = ''; 
            $('.blade-combo-option').removeClass('active');
            $(this).addClass('active');
            
            var bladeCombo = $(this).attr('data-bladecombo');

            //Build our custom fan with the select blade combination.
            if (bladeCombo == 'combo') {
                $('#fan-customizer .blade-1, #fan-customizer .blade-3').addClass('default').attr('data-bladestyle', 'goalie').find('img').attr('src', blankGoalieBlade);
                $('#fan-customizer .blade-2, #fan-customizer .blade-4').addClass('default').attr('data-bladestyle', 'hockey').find('img').attr('src', blankHockeyBlade);
            } else if (bladeCombo == 'hockey') {
                $('#fan-customizer .blade').addClass('default').attr('data-bladestyle', bladeCombo).find('img').attr('src', blankHockeyBlade);
            } else {
                $('#fan-customizer .blade').addClass('default').attr('data-bladestyle', bladeCombo).find('img').attr('src', blankGoalieBlade);
            }

            //The user changed the blade combo, so slide up the cart section and slide down the builder.
            $('#addtocartwrap').slideUp(500);
            $('#fan-customizer').slideDown(500);

            //Scroll to the fan customizer
            $('html,body').animate({ scrollTop: $('#fan-customizer').offset().top - 20 }, 'slow');
        });

        $('body').on('click', '#changebladeteam', function (e) {
            e.preventDefault();
            
            $("#bladepicker").removeClass('active').slideUp(0);
            $("#bladeteampicker").addClass('active').slideDown(0);
        });

        $('body').on('click', '#changelensteam', function (e) {
            e.preventDefault();
            
            $("#lenspicker").removeClass('active').slideUp(0);
            $("#lensteampicker").addClass('active').slideDown(0);
        });

        var bladeTeamSelected = false;

        $('body').on('click', '#custom-fan .pick-blade-trigger', function (e) {
            e.preventDefault();
            
            $activeBlade = $(this);

            if (!bladeTeamSelected && getUrlParameter('team')) {
                $('#bladeteampicker .option[data-teamid="' + getUrlParameter('team') + '"]').trigger('click');
            }

            if ($("#bladepicker").hasClass('active')) {
                //Build a fan varient picker.
                var $bladeOptions = $("#bladepicker .select");
                $bladeOptions.html('');

                $.each(blade_variants, function (i, variant) {
                    if (variant.teamid == currentBladeTeamID && variant.blade == $activeBlade.attr('data-bladestyle')) {
                        $bladeOptions.append("<div class=\"option\" data-variantid=\"" + variant.id + "\" data-title=\"" + variant.title + "\"><img src=\"" + variant.thumb + "\" alt=\"" + variant.title + "\" /></div>");
                    }
                });
            }
        });

        //In our Lity Lightbox, when someone picks a team, we'll switch to the blade picker and let them pick a blade.
        $('body').on('click', '#bladeteampicker .option', function (e) {
            e.preventDefault();
            
            //Build a fan varient picker dropdown.
            bladeTeamSelected = true;
            var $bladeOptions = $("#bladepicker .select");
            $bladeOptions.html('');

            currentBladeTeamID = $(this).attr('data-teamid');

            $.each(blade_variants, function (i, variant) {
                if (variant.teamid == currentBladeTeamID && variant.blade == $activeBlade.attr('data-bladestyle')) {
                    $bladeOptions.append("<div class=\"option\" data-variantid=\"" + variant.id + "\" data-title=\"" + variant.title + "\"><img src=\"" + variant.thumb + "\" alt=\"" + variant.title + "\" /></div>");
                }
            });

            $("#bladeteampicker").removeClass('active').slideUp(0);
            $("#bladepicker").addClass('active').slideDown(0);
        });

        //When someone picks a blade, we'll change that blade in our fan and close the lightbox.
        $('body').on('click', '#bladepicker .option', function (e) {
            e.preventDefault();
            
            var selectedBladeID = $(this).attr('data-variantid');
            var selectedBladeTitle = $(this).attr('data-title');

            $.each(blade_variants, function (i, el) {
                if (selectedBladeID == el.id) {
                    $activeBlade.attr('data-variantid', el.id).attr('data-title', selectedBladeTitle).removeClass("default");
                    $('img', $activeBlade).attr('src', el.img);
                }
            });

            //Slide down the cart once the user picks a blade.
            if ($('#custom-fan .blade.default').length <= 0) {
                $('#addtocartwrap').slideDown(500);
            }

            $('[data-lity-close]', window.parent.document).trigger('click');
        });

        var lensTeamSelected = false;

        $('body').on('click', '#custom-fan .pick-lens-trigger', function (e) {
            e.preventDefault();
            
            if (!lensTeamSelected && getUrlParameter('team')) {
                $('#lensteampicker .option[data-teamid="' + getUrlParameter('team') + '"]').trigger('click');
            }

            if ($("#lenspicker").hasClass('active')) {
                //Build a fan varient picker.
                var $lensOptions = $("#lenspicker .select");
                $lensOptions.html('');

                $.each(lens_variants, function (i, variant) {
                    if (variant.teamid == currentLensTeamID) {
                        $lensOptions.append("<div class=\"option\" data-variantid=\"" + variant.id + "\" data-title=\"" + variant.title + "\"><img src=\"" + variant.thumb + "\" alt=\"" + variant.title + "\" /></div>");
                    }
                });
            }
        });

        //In our Lity Lightbox, when someone picks a team, we'll switch to the lens picker and let them pick a lens.
        $('body').on('click', '#lensteampicker .option', function (e) {
            e.preventDefault();
            
            //Build a fan varient picker dropdown.
            lensTeamSelected = true;
            var $lensOptions = $("#lenspicker .select");
            $lensOptions.html('');

            currentLensTeamID = $(this).attr('data-teamid');

            $.each(lens_variants, function (i, variant) {
                if (variant.teamid == currentLensTeamID) {
                    $lensOptions.append("<div class=\"option\" data-variantid=\"" + variant.id + "\" data-title=\"" + variant.title + "\"><img src=\"" + variant.thumb + "\" alt=\"" + variant.title + "\" /></div>");
                }
            });

            $("#lensteampicker").removeClass('active').slideUp(0);
            $("#lenspicker").addClass('active').slideDown(0);
        });

        //When someone picks a lens, we'll change that lens in our fan and close the lightbox.
        $('body').on('click', '#lenspicker .option', function (e) {
            e.preventDefault();
            
            var selectedLensID = $(this).attr('data-variantid');
            var selectedLensTitle = $(this).attr('data-title');

            $.each(lens_variants, function (i, el) {
                if (selectedLensID == el.id) {
                    var $puck = $('#fan-customizer .fixture.hockey-puck');

                    $puck.attr('data-variantid', el.id).attr('data-title', selectedLensTitle).removeClass("default");
                    $('img.lens', $puck).attr('src', el.img);
                }
            });

            //Slide down the cart once the user picks a lens.
            if ($('#custom-fan .fixture.default').length <= 0) {
                $('#addtocartwrap').slideDown(500);
            }

            $('[data-lity-close]', window.parent.document).trigger('click');
        });

        $('[data-lity], [href="#"]').on('click', function (e) {
            e.preventDefault();
        });
        
        //Catch the click action to add a custom fan to our cart.
        $('#addtocart').on('click', function () {
            var fanOrder = [];
            var count = 0;

            $(this).prop('disabled', true);

            var fanLineItem = {
                quantity: 1,
                id: productVariantID,
                properties: {
                    '_fan': fanNumber
                }
            };

            var $activeFixture = $('#fan-fixture-picker .fan-fixture-option.active');

            //If this is a puck fixture, we need to add the lens to the order.
            if ($activeFixture.data('fixture') == 'hockey-puck') {
                var $puck = $('#fan-customizer .fixture.hockey-puck');
                fanLineItem.properties['_lens_img'] = $puck.find('img.lens').attr('src');
                fanLineItem.properties['_lens_variantid'] = $puck.attr('data-variantid');
                fanLineItem.properties['_lens_title'] = $puck.attr('data-title');
            }

            $('.blade').each(function () {
                fanLineItem.properties['_blade_' + count + '_img'] = $(this).find('img').attr('src');
                fanLineItem.properties['_blade_' + count + '_variantid'] = $(this).attr('data-variantid');
                fanLineItem.properties['_blade_' + count + '_title'] = $(this).attr('data-title');

                count++;
            });

            // console.log(fanLineItem);
            fanOrder.push(fanLineItem);

            $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                type: 'post',
                data: { items: fanOrder },
                success: function success() {
                    $(this).prop('disabled', false);
                    window.location.replace("/cart");
                },
                error: function error(XMLHttpRequest) {
                    $(this).prop('disabled', false);
                    var data = eval('(' + XMLHttpRequest.responseText + ')');
                    // var response = data.description;
                    // var status = XMLHttpRequest.status;
                    // console.log('Add To Cart Error' + response);
                }
            });
        });
    }
})(jQuery);
"use strict";

jQuery(function ($) {});
'use strict';

$('.product-form__input input[type="radio"][value="Goalie"]').each(function() {
  $(this).next().remove();
  $(this).remove();
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! Lity - v2.4.1 - 2020-04-26
* http://sorgalla.com/lity/
* Copyright (c) 2015-2020 Jan Sorgalla; Licensed MIT */
(function (window, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], function ($) {
            return factory(window, $);
        });
    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && _typeof(module.exports) === 'object') {
        module.exports = factory(window, require('jquery'));
    } else {
        window.lity = factory(window, window.jQuery || window.Zepto);
    }
})(typeof window !== "undefined" ? window : undefined, function (window, $) {
    'use strict';

    var document = window.document;

    var _win = $(window);
    var _deferred = $.Deferred;
    var _html = $('html');
    var _instances = [];

    var _attrAriaHidden = 'aria-hidden';
    var _dataAriaHidden = 'lity-' + _attrAriaHidden;

    var _focusableElementsSelector = 'a[href],area[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled]),iframe,object,embed,[contenteditable],[tabindex]:not([tabindex^="-"])';

    var _defaultOptions = {
        esc: true,
        handler: null,
        handlers: {
            image: imageHandler,
            inline: inlineHandler,
            youtube: youtubeHandler,
            vimeo: vimeoHandler,
            googlemaps: googlemapsHandler,
            facebookvideo: facebookvideoHandler,
            iframe: iframeHandler
        },
        template: '<div class="lity" role="dialog" aria-label="Dialog Window (Press escape to close)" tabindex="-1"><div class="lity-wrap" data-lity-close role="document"><div class="lity-loader" aria-hidden="true">Loading...</div><div class="lity-container"><div class="lity-content"></div><button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close>&times;</button></div></div></div>'
    };

    var _imageRegexp = /(^data:image\/)|(\.(png|jpe?g|gif|svg|webp|bmp|ico|tiff?)(\?\S*)?$)/i;
    var _youtubeRegex = /(youtube(-nocookie)?\.com|youtu\.be)\/(watch\?v=|v\/|u\/|embed\/?)?([\w-]{11})(.*)?/i;
    var _vimeoRegex = /(vimeo(pro)?.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/;
    var _googlemapsRegex = /((maps|www)\.)?google\.([^\/\?]+)\/?((maps\/?)?\?)(.*)/i;
    var _facebookvideoRegex = /(facebook\.com)\/([a-z0-9_-]*)\/videos\/([0-9]*)(.*)?$/i;

    var _transitionEndEvent = function () {
        var el = document.createElement('div');

        var transEndEventNames = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend'
        };

        for (var name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return transEndEventNames[name];
            }
        }

        return false;
    }();

    function transitionEnd(element) {
        var deferred = _deferred();

        if (!_transitionEndEvent || !element.length) {
            deferred.resolve();
        } else {
            element.one(_transitionEndEvent, deferred.resolve);
            setTimeout(deferred.resolve, 500);
        }

        return deferred.promise();
    }

    function settings(currSettings, key, value) {
        if (arguments.length === 1) {
            return $.extend({}, currSettings);
        }

        if (typeof key === 'string') {
            if (typeof value === 'undefined') {
                return typeof currSettings[key] === 'undefined' ? null : currSettings[key];
            }

            currSettings[key] = value;
        } else {
            $.extend(currSettings, key);
        }

        return this;
    }

    function parseQueryParams(params) {
        var pairs = decodeURI(params.split('#')[0]).split('&');
        var obj = {},
            p;

        for (var i = 0, n = pairs.length; i < n; i++) {
            if (!pairs[i]) {
                continue;
            }

            p = pairs[i].split('=');
            obj[p[0]] = p[1];
        }

        return obj;
    }

    function appendQueryParams(url, params) {
        return url + (url.indexOf('?') > -1 ? '&' : '?') + $.param(params);
    }

    function transferHash(originalUrl, newUrl) {
        var pos = originalUrl.indexOf('#');

        if (-1 === pos) {
            return newUrl;
        }

        if (pos > 0) {
            originalUrl = originalUrl.substr(pos);
        }

        return newUrl + originalUrl;
    }

    function error(msg) {
        return $('<span class="lity-error"></span>').append(msg);
    }

    function imageHandler(target, instance) {
        var desc = instance.opener() && instance.opener().data('lity-desc') || 'Image with no description';
        var img = $('<img src="' + target + '" alt="' + desc + '"/>');
        var deferred = _deferred();
        var failed = function failed() {
            deferred.reject(error('Failed loading image'));
        };

        img.on('load', function () {
            if (this.naturalWidth === 0) {
                return failed();
            }

            deferred.resolve(img);
        }).on('error', failed);

        return deferred.promise();
    }

    imageHandler.test = function (target) {
        return _imageRegexp.test(target);
    };

    function inlineHandler(target, instance) {
        var el, placeholder, hasHideClass;

        try {
            el = $(target);
        } catch (e) {
            return false;
        }

        if (!el.length) {
            return false;
        }

        placeholder = $('<i style="display:none !important"></i>');
        hasHideClass = el.hasClass('lity-hide');

        instance.element().one('lity:remove', function () {
            placeholder.before(el).remove();

            if (hasHideClass && !el.closest('.lity-content').length) {
                el.addClass('lity-hide');
            }
        });

        return el.removeClass('lity-hide').after(placeholder);
    }

    function youtubeHandler(target) {
        var matches = _youtubeRegex.exec(target);

        if (!matches) {
            return false;
        }

        return iframeHandler(transferHash(target, appendQueryParams('https://www.youtube' + (matches[2] || '') + '.com/embed/' + matches[4], $.extend({
            autoplay: 1
        }, parseQueryParams(matches[5] || '')))));
    }

    function vimeoHandler(target) {
        var matches = _vimeoRegex.exec(target);

        if (!matches) {
            return false;
        }

        return iframeHandler(transferHash(target, appendQueryParams('https://player.vimeo.com/video/' + matches[3], $.extend({
            autoplay: 1
        }, parseQueryParams(matches[4] || '')))));
    }

    function facebookvideoHandler(target) {
        var matches = _facebookvideoRegex.exec(target);

        if (!matches) {
            return false;
        }

        if (0 !== target.indexOf('http')) {
            target = 'https:' + target;
        }

        return iframeHandler(transferHash(target, appendQueryParams('https://www.facebook.com/plugins/video.php?href=' + target, $.extend({
            autoplay: 1
        }, parseQueryParams(matches[4] || '')))));
    }

    function googlemapsHandler(target) {
        var matches = _googlemapsRegex.exec(target);

        if (!matches) {
            return false;
        }

        return iframeHandler(transferHash(target, appendQueryParams('https://www.google.' + matches[3] + '/maps?' + matches[6], {
            output: matches[6].indexOf('layer=c') > 0 ? 'svembed' : 'embed'
        })));
    }

    function iframeHandler(target) {
        return '<div class="lity-iframe-container"><iframe frameborder="0" allowfullscreen allow="autoplay; fullscreen" src="' + target + '"/></div>';
    }

    function winHeight() {
        return document.documentElement.clientHeight ? document.documentElement.clientHeight : Math.round(_win.height());
    }

    function keydown(e) {
        var current = currentInstance();

        if (!current) {
            return;
        }

        // ESC key
        if (e.keyCode === 27 && !!current.options('esc')) {
            current.close();
        }

        // TAB key
        if (e.keyCode === 9) {
            handleTabKey(e, current);
        }
    }

    function handleTabKey(e, instance) {
        var focusableElements = instance.element().find(_focusableElementsSelector);
        var focusedIndex = focusableElements.index(document.activeElement);

        if (e.shiftKey && focusedIndex <= 0) {
            focusableElements.get(focusableElements.length - 1).focus();
            e.preventDefault();
        } else if (!e.shiftKey && focusedIndex === focusableElements.length - 1) {
            focusableElements.get(0).focus();
            e.preventDefault();
        }
    }

    function resize() {
        $.each(_instances, function (i, instance) {
            instance.resize();
        });
    }

    function registerInstance(instanceToRegister) {
        if (1 === _instances.unshift(instanceToRegister)) {
            _html.addClass('lity-active');

            _win.on({
                resize: resize,
                keydown: keydown
            });
        }

        $('body > *').not(instanceToRegister.element()).addClass('lity-hidden').each(function () {
            var el = $(this);

            if (undefined !== el.data(_dataAriaHidden)) {
                return;
            }

            el.data(_dataAriaHidden, el.attr(_attrAriaHidden) || null);
        }).attr(_attrAriaHidden, 'true');
    }

    function removeInstance(instanceToRemove) {
        var show;

        instanceToRemove.element().attr(_attrAriaHidden, 'true');

        if (1 === _instances.length) {
            _html.removeClass('lity-active');

            _win.off({
                resize: resize,
                keydown: keydown
            });
        }

        _instances = $.grep(_instances, function (instance) {
            return instanceToRemove !== instance;
        });

        if (!!_instances.length) {
            show = _instances[0].element();
        } else {
            show = $('.lity-hidden');
        }

        show.removeClass('lity-hidden').each(function () {
            var el = $(this),
                oldAttr = el.data(_dataAriaHidden);

            if (!oldAttr) {
                el.removeAttr(_attrAriaHidden);
            } else {
                el.attr(_attrAriaHidden, oldAttr);
            }

            el.removeData(_dataAriaHidden);
        });
    }

    function currentInstance() {
        if (0 === _instances.length) {
            return null;
        }

        return _instances[0];
    }

    function factory(target, instance, handlers, preferredHandler) {
        var handler = 'inline',
            content;

        var currentHandlers = $.extend({}, handlers);

        if (preferredHandler && currentHandlers[preferredHandler]) {
            content = currentHandlers[preferredHandler](target, instance);
            handler = preferredHandler;
        } else {
            // Run inline and iframe handlers after all other handlers
            $.each(['inline', 'iframe'], function (i, name) {
                delete currentHandlers[name];

                currentHandlers[name] = handlers[name];
            });

            $.each(currentHandlers, function (name, currentHandler) {
                // Handler might be "removed" by setting callback to null
                if (!currentHandler) {
                    return true;
                }

                if (currentHandler.test && !currentHandler.test(target, instance)) {
                    return true;
                }

                content = currentHandler(target, instance);

                if (false !== content) {
                    handler = name;
                    return false;
                }
            });
        }

        return { handler: handler, content: content || '' };
    }

    function Lity(target, options, opener, activeElement) {
        var self = this;
        var result;
        var isReady = false;
        var isClosed = false;
        var element;
        var content;

        options = $.extend({}, _defaultOptions, options);

        element = $(options.template);

        // -- API --

        self.element = function () {
            return element;
        };

        self.opener = function () {
            return opener;
        };

        self.options = $.proxy(settings, self, options);
        self.handlers = $.proxy(settings, self, options.handlers);

        self.resize = function () {
            if (!isReady || isClosed) {
                return;
            }

            content.css('max-height', winHeight() + 'px').trigger('lity:resize', [self]);
        };

        self.close = function () {
            if (!isReady || isClosed) {
                return;
            }

            isClosed = true;

            removeInstance(self);

            var deferred = _deferred();

            // We return focus only if the current focus is inside this instance
            if (activeElement && (document.activeElement === element[0] || $.contains(element[0], document.activeElement))) {
                try {
                    activeElement.focus();
                } catch (e) {
                    // Ignore exceptions, eg. for SVG elements which can't be
                    // focused in IE11
                }
            }

            content.trigger('lity:close', [self]);

            element.removeClass('lity-opened').addClass('lity-closed');

            transitionEnd(content.add(element)).always(function () {
                content.trigger('lity:remove', [self]);
                element.remove();
                element = undefined;
                deferred.resolve();
            });

            return deferred.promise();
        };

        // -- Initialization --

        result = factory(target, self, options.handlers, options.handler);

        element.attr(_attrAriaHidden, 'false').addClass('lity-loading lity-opened lity-' + result.handler).appendTo('body').focus().on('click', '[data-lity-close]', function (e) {
            if ($(e.target).is('[data-lity-close]')) {
                self.close();
            }
        }).trigger('lity:open', [self]);

        registerInstance(self);

        $.when(result.content).always(ready);

        function ready(result) {
            content = $(result).css('max-height', winHeight() + 'px');

            element.find('.lity-loader').each(function () {
                var loader = $(this);

                transitionEnd(loader).always(function () {
                    loader.remove();
                });
            });

            element.removeClass('lity-loading').find('.lity-content').empty().append(content);

            isReady = true;

            content.trigger('lity:ready', [self]);
        }
    }

    function lity(target, options, opener) {
        if (!target.preventDefault) {
            opener = $(opener);
        } else {
            target.preventDefault();
            opener = $(this);
            target = opener.data('lity-target') || opener.attr('href') || opener.attr('src');
        }

        var instance = new Lity(target, $.extend({}, opener.data('lity-options') || opener.data('lity'), options), opener, document.activeElement);

        if (!target.preventDefault) {
            return instance;
        }
    }

    lity.version = '2.4.1';
    lity.options = $.proxy(settings, lity, _defaultOptions);
    lity.handlers = $.proxy(settings, lity, _defaultOptions.handlers);
    lity.current = currentInstance;

    $(document).on('click.lity', '[data-lity]', lity);

    return lity;
});
